export function capitalize(word) {
  return word.replace(/^./, (ch) => ch.toUpperCase());
}

export function encodeBase64(value: string): string {
  const bytes = new TextEncoder().encode(value);
  return btoa(Array.from(bytes, (byte) => String.fromCharCode(byte)).join(''));
}

export function camelCaseToText(string: string): string {
  const camelSplitter = /(.)([A-Z]+)/g;
  return string.replace(
    camelSplitter,
    (_, previous, uppers) => previous + ' ' + uppers.toLowerCase().split('').join(' ')
  );
}
